import { LowBalanceAlert } from "@client/components/credits/low-balance-alert";
import { Loader } from "@client/components/navbar/loader";
import { ActiveJobsBanner } from "@client/components/ui/active-jobs-banner";
import { authClient } from "@client/lib/auth-client";
import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)")({
	component: Layout,
});

function Layout() {
	const { data: session, isPending } = authClient.useSession();

	if (isPending) {
		return <Loader />;
	}

	if (!session?.user) {
		return <Navigate to="/" />;
	}

	return (
		<>
			<LowBalanceAlert />
			<ActiveJobsBanner />
			<Outlet />
		</>
	);
}
